import React from 'react';
import localeZh from 'antd/locale/zh_CN';
import localeEn from 'antd/locale/en_US';
import { Button, ConfigProvider, DatePicker, Form, Modal, Space } from 'antd';
import type { FormProps } from 'antd';
import dayjs from 'dayjs';
import { withTranslation, WithTranslation } from 'react-i18next';

interface ModalDelSdkLogBeforeDateProps {
    isModalOpen: boolean;
    handleOk: (date: string) => void;
    handleCancel: () => void;
}

interface FieldType {
    date?: dayjs.Dayjs;
}

class _ModalDelSdkLogBeforeDate extends React.Component<
    WithTranslation & ModalDelSdkLogBeforeDateProps
> {
    handleFinish: FormProps<FieldType>['onFinish'] = (values) => {
        if (values.date) {
            this.props.handleOk(values.date.format('YYYY-MM-DD'));
        }
    };

    render() {
        const { t, i18n, isModalOpen, handleCancel } = this.props;
        const locale = i18n.language === 'zh_CN' ? localeZh : localeEn;

        return (
            <ConfigProvider locale={locale}>
                <Modal
                    centered
                    title={t('title-del-sdklog-before-date')}
                    open={isModalOpen}
                    destroyOnClose
                    closeIcon={false}
                    footer={null}
                    onCancel={handleCancel}
                >
                    <Form<FieldType>
                        name="deleteLogBeforeDate"
                        layout="vertical"
                        onFinish={this.handleFinish}
                        autoComplete="off"
                    >
                        <Form.Item<FieldType>
                            label={t('date')}
                            name="date"
                            rules={[{ required: true, message: t('hint-add-date') }]}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format="YYYY-MM-DD"
                            />
                        </Form.Item>

                        <Form.Item style={{ marginBottom: 0 }}>
                            <Space>
                                <Button type="primary" htmlType="submit">
                                    {t('confirm')}
                                </Button>
                                <Button onClick={handleCancel}>
                                    {t('cancel')}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </Modal>
            </ConfigProvider>
        );
    }
}

export const ModalDelSdkLogBeforeDate = withTranslation()(_ModalDelSdkLogBeforeDate);
